export default __webpack_public_path__ + "static/media/unity.5103c8d1.svg";